import { BaseService } from './base-service';
import { GetErgonomicToolListMapper } from '@/core/mapper/ergonomic-tool';
import type { DefaultOptionType } from 'antd/es/select';
import type {
	GetErgonomicToolListRequestDTO,
	GetErgonomicToolListResponseDTO,
	GetErgonomicToolsByReportRequestDTO,
	GetErgonomicToolsByReportResponseDTO
} from '@/core/dto/ergonomic-tool';

export class ErgonomicToolsService extends BaseService<GetErgonomicToolListResponseDTO> {
	private static instance: ErgonomicToolsService;

	private constructor(public readonly basePath = '/ergonomic-tool') {
		super();
	}

	public static getInstance(): ErgonomicToolsService {
		if (!ErgonomicToolsService.instance) {
			ErgonomicToolsService.instance = new ErgonomicToolsService();
		}
		return ErgonomicToolsService.instance;
	}

	public async findAll(params: GetErgonomicToolListRequestDTO): Promise<DefaultOptionType[]> {
		const url = this.basePath;
		const { data } = await this.getInstance().get<GetErgonomicToolListResponseDTO>(url, { params });
		return new GetErgonomicToolListMapper(data).toDomain();
	}

	public async findAllByReport(
		params: GetErgonomicToolsByReportRequestDTO
	): Promise<GetErgonomicToolsByReportResponseDTO[]> {
		const url = this.basePath + `/list-and-count/`;
		const { data } = await this.getInstance().get<GetErgonomicToolsByReportResponseDTO[]>(url, { params });
		return data;
	}
}
